<template>
    <div id="file-player">
        <a :href="fileSrc" class="download-btn" download target="_blank">
            <span class="iconify" data-icon="akar-icons:download" data-inline="false"></span>
            <span style="margin: 0 10px 0 0">{{fileType}}</span>
            <button class="status-btn">
                <i v-if="currentStatus==='sent'" class="fa fa-check" aria-hidden="true"></i>
                <i v-else-if="currentStatus==='send'" class="fa fa-spinner loading" aria-hidden="true"></i>
                <i v-else class="fa fa-warning" aria-hidden="true"></i>
            </button>
        </a>
    </div>
    <div   v-bind:class="{ 'expert-comment-time' : side==='admin' , 'user-comment-time' : side==='user' }">
        <span>
            {{createdAt}}

               <span v-if="side==='admin'" class="sender-details">
                    /
               <span v-if="relatedAdmin.role === 'Deputy'">
                   معاون
               </span>
               <span v-else-if="relatedAdmin.role === 'DepartmentHead'">
                   مدیر گروه
               </span>
               <span v-else-if="relatedAdmin.role === 'GeneralManager'">
                   مدیر دپارتمان
               </span>
               <span v-else-if="relatedAdmin.role === 'Expert'">
               <span v-if="relatedAdmin.type === 'Expert_Client'">
                   کارشناس اصلی
               </span>
               <span v-else-if="relatedAdmin.type === 'AlongExpert_Client'">
                  کارشناس همراه
               </span>
               <span v-else>
                   کارشناس
               </span>
               </span>
               <span v-else>
                  مدیر کل
               </span>
            </span>
        </span>
        <button class="status-btn" v-if="side==='user'">
        <span v-if="currentStatus==='sent'">
        <span class="iconify" data-icon="bi:check" data-inline="false"></span>
        </span>
            <span class="loading" v-else-if="currentStatus==='send'">
             <span class="iconify" data-icon="uil:spinner-alt" data-inline="false"></span>
            </span>
            <span v-else>
        <span class="iconify" data-icon="ant-design:warning-outlined" data-inline="false"></span>
        </span>
        </button>
    </div>
</template>
<script>
    import axios from 'axios'
    export default {
        name: "FilePlayer",
        data(){return {currentStatus:'sent'}},
        props: {
            side: String,
            fileSrc: String,
            uniqueId: String,
            fileType: String,
            currentDate: String,
            status: String,
            submitKey: Number,
            filePreviousName:String,
            currentUserDetails:Object,
            fileContent:File,
            createdAt: String,
            relatedAdmin:Object
        },
        methods:{
             upload(){
                    this.currentStatus = this.status;
                    const formData = new FormData();
                    formData.append('file', this.fileContent);
                    formData.append('file_previous_name', this.filePreviousName);
                    axios.post('/api/userDashboard/chatFileStore',formData, {
                        headers:
                            {
                                "Authorization": `Bearer ${localStorage.getItem('token')}`,
                                "Content-Type": "multipart/form-data",
                            }
                    }).then(response => {
                        this.currentStatus = 'sent';
                        console.log(response) ;
                        this.currentStatus = 'sent';
                    }).catch(error => {
                        this.currentStatus = 'error';
                        console.log(error);
                    });
            }
        },
        mounted() {
            let localStorageCurrentDate = localStorage.getItem('currentDate');
            console.log(this.currentDate ,'prop');
            console.log(localStorageCurrentDate ,'local');
            if(this.currentDate === localStorageCurrentDate){
                this.upload();
            }
        }
    }
</script>
<style lang="scss" scoped>
    #file-player{padding: 0}
    .download-btn{
        display: flex;
        justify-content: center;
        align-items: center;
        border: none;
        width: max-content;
        height: 27px;
        cursor: pointer;
        background: transparent;
        color: black;
        margin: 0;
        .iconify{
            font-size: 20px;
        }
        span{
            font-size: 15px;
        }
    }
    .loading{
        -webkit-animation:spin 1s linear infinite;
        -moz-animation:spin 1s linear infinite;
        animation:spin 1s linear infinite;
    }
    @-moz-keyframes spin { 100% { -moz-transform: rotate(360deg); } }
    @-webkit-keyframes spin { 100% { -webkit-transform: rotate(360deg); } }
    @keyframes spin { 100% { -webkit-transform: rotate(360deg); transform:rotate(360deg); } }
    .download-btn{
        margin: 0 5px 0 5px;
    }
    .expert-comment-time,.user-comment-time{
        display: flex !important;
        opacity: 0.5;
        font-family: IRANSans;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        text-align: right;
        color: #000000;
        width: 100%;
        height: 30px;
        line-height: 30px;
    }
    .user-comment-time{
        justify-content: flex-end;
    }
    .expert-comment-time{

    }
    .action-btn{
        font-size: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: none;
        cursor: pointer;
        background: transparent;
        color: black;
        margin:0;
        span{
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
    .status-btn{
        background: transparent;
        color: black;
        margin:0;
        span{
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 20px;
        }
    }
</style>